import React, { useState } from 'react';
import { bool, object, func } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableRowMenu.module.css';

const SensorsTableRowMenu = ({
    calculatedSensor,
    hidden,
    isRuntimeCalculation,
    onResetCalculation,
    onResetCalculationModal,
    onToggleDeleteSensorModal,
    onToggleEditSensorModal,
    onTogglePreviewDataModal,
    sensor,
    setSensor
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setSensor(sensor);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handlePreviewData() {
        onTogglePreviewDataModal(true);

        handleClose();
    }

    function handleEditSensor() {
        onToggleEditSensorModal(true);

        handleClose();
    }

    function handleDeleteSensor() {
        onToggleDeleteSensorModal(true);

        handleClose();
    }

    function onCalculationReset () {
        onResetCalculation(sensor);
        handleClose();
    }

    const resetCalculationClick = () => {
        onResetCalculationModal(sensor);
        handleClose();
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    process.env.sensorDataModalEnabled &&
                        <MenuItem onClick={handlePreviewData}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/actionBarItem-data.svg"
                            />
                            Preview Data
                        </MenuItem>
                }
                {
                    !calculatedSensor ?
                        <MenuItem onClick={handleEditSensor}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/SettingsFlat.svg"
                            />
                            Edit Sensor
                        </MenuItem>
                        :
                        null
                }
                <MenuItem onClick={handleDeleteSensor}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete Sensor
                </MenuItem>
                {
                    isRuntimeCalculation ?
                        <MenuItem onClick={resetCalculationClick}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/reseticonFlat.svg"
                            />
                            Reset Calculation
                        </MenuItem>
                        : null
                }
                {
                    isRuntimeCalculation ?
                        <MenuItem onClick={onCalculationReset}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/reseticonFlat.svg"
                            />
                            Reset
                        </MenuItem>
                        : null
                }
            </Menu>
        </React.Fragment>
    );
};

SensorsTableRowMenu.defaultProps = {
    hidden:                    false,
    onToggleDeleteSensorModal: () => { },
    onToggleEditSensorModal:   () => { },
    onTogglePreviewDataModal:  () => { },
    sensor:                    {},
    setSensor:                 () => { }
};

SensorsTableRowMenu.propTypes = {
    hidden:                    bool,
    onToggleDeleteSensorModal: func,
    onToggleEditSensorModal:   func,
    onTogglePreviewDataModal:  func,
    sensor:                    object,
    setSensor:                 func
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default withRouter(
    connect(null, mapDispatchToProps)(SensorsTableRowMenu)
);
